// extracted by mini-css-extract-plugin
module.exports = {"filtersattributes__list":"FiltersAttributes-module__filtersattributes__list___lfbzV","filtersattributes__item":"FiltersAttributes-module__filtersattributes__item___3HUWL"};